// eslint-disable-next-line import/prefer-default-export
export const REGULAR_EXPRESSIONS = {
  // no unicodes from u2460-24FF, no numbers and no special chars
  name: /^[^\u2460-\u24FF^0-9`!@#$%^&*+_=]+$/,
  // a-Z, numbers, hyphen and underscore
  username: /^[a-zA-Z0-9-_]+$/,
  invitationCode: /^[a-zA-Z0-9]+$/,
  onlyOneAlphanumeric: /^([a-zA-Z0-9]{1})$/,
}
